import { withTransaction } from '@elastic/apm-rum-react'
import { FitProfile, FitRequirements, SuggestionRules, Tag } from '@hub/shared'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import './register-requirements.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  suggestionRules: SuggestionRules
  fitRequirements: FitRequirements
}

const RegisterRequirementsComponent = ({ suggestionRules, fitRequirements }: Props) => {
  const [t] = useTranslation('registerRequirements')

  const requirements = useMemo(
    () => [
      {
        label: t('cities'),
        value: suggestionRules?.cities,
        key: 'cities',
      },
      {
        label: t('ufs'),
        value: suggestionRules?.ufs,
        key: 'ufs',
      },
      {
        label: t('countries'),
        value: suggestionRules?.countries,
        key: 'countries',
      },
      {
        label: t('minAge'),
        value: suggestionRules?.age,
        key: 'age',
      },
      {
        label: t('maxAge'),
        value: suggestionRules?.maxAge,
        key: 'maxAge',
      },
    ],
    [t, suggestionRules]
  )

  const handleVerifyRequirements = (field: string) => {
    const fitRequirementsUser = fitRequirements?.fits?.fitProfile
    if (field && fitRequirementsUser?.find((fit: FitProfile) => fit?.rule === field)?.fit) {
      return 'fa-solid fa-circle-check'
    }
    return 'fa-solid fa-circle-xmark'
  }

  const handleVerifyRender = (value: any) => fitRequirements?.fits?.fitProfile?.find((fit: FitProfile) => fit?.rule == value)

  if (suggestionRules?.ufs?.length < 1 && suggestionRules?.countries?.length < 1 && !suggestionRules?.age && !suggestionRules?.maxAge) {
    return null
  }

  return (
    <section className="register-requirements">
      <div className="title">
        <h5>{t('title')}</h5>
        <p>{t('subTitle')}:</p>
      </div>
      {requirements?.map((requirement: any) =>
        handleVerifyRender(requirement.key) ? (
          !['maxAge']?.includes(requirement?.key) ? (
            <Tag
              key={requirement.key}
              icon={
                <span className="icon-register-requirements">
                  <i
                    className={`${
                      ['cities', 'ufs', 'countries'].includes(requirement.key) ? 'fa-light fa-earth-americas' : 'fa-light fa-image-user'
                    }`}
                    style={{ color: 'var(--text_color)' }}
                  ></i>
                  <div className="check">
                    <i
                      className={`${handleVerifyRequirements(requirement.key)}`}
                      style={{
                        color: handleVerifyRequirements(requirement.key) === 'fa-solid fa-circle-check' ? 'var(--green)' : 'var(--red)',
                      }}
                    ></i>
                  </div>
                </span>
              }
              labels={
                <p>
                  {`${requirement.label}: `}
                  <strong>
                    {`
                  ${
                    ['cities', 'ufs', 'countries'].includes(requirement?.key) && requirement?.value?.length > 1
                      ? requirement?.value?.join(', ')
                      : requirement?.value
                  } 
                  ${['age', 'maxAge'].includes(requirement?.key) ? t('yearsOld') : ''}
                `}
                  </strong>
                </p>
              }
            />
          ) : null
        ) : null
      )}
    </section>
  )
}

export default withTransaction('RegisterRequirementsComponent', 'component')(RegisterRequirementsComponent)
